import gql from 'graphql-tag'
export default gql`query plantsQuery {
  plants {
    name
    id
  }
}`